/*
 * Copyright (C) 2019 Toshiba Corporation
 * SPDX-License-Identifier: Apache-2.0
 */

import { DThemeChartLegend } from "../../d-chart-legend";
import { DThemeWhiteBase } from "./d-theme-white-base";

export class DThemeWhiteChartLegend extends DThemeWhiteBase implements DThemeChartLegend {}
